// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"a7f3706a96a814943d65","655":"8b6ff11451fc96d21c43"}[chunkId] + ".js";
};